import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getFacetItemByUid } from 'app/products/productsReducer';
import { removeFacetItem as removeFacetItemAction } from '../facetsListActions';

const AppliedFacetItem = ({ facetItem, removeFacetItem }) => {
  const onClickHandler = () => removeFacetItem(facetItem);

  return (
    facetItem && (
      <li className="applied-facets-list__item" role="alert">
        {facetItem.name}
        <button
          type="button"
          className="applied-facets-list__remove-button button-reset-complete icon-times"
          onClick={onClickHandler}
        />
      </li>
    )
  );
};

AppliedFacetItem.defaultProps = {
  facetItem: null,
};
AppliedFacetItem.propTypes = {
  facetItem: PropTypes.shape({
    id: PropTypes.string.isRequired,
    uid: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    facet: PropTypes.string.isRequired,
  }),
  removeFacetItem: PropTypes.func.isRequired,
};

const mapStateToProps = (state, { uid }) => ({
  facetItem: getFacetItemByUid(state, uid),
});

const mapDispatch = {
  removeFacetItem: removeFacetItemAction,
};

export default connect(
  mapStateToProps,
  mapDispatch
)(AppliedFacetItem);
